module.exports = __webpack_public_path__ + "img/feature-1-2.89def329.png";